module.exports = __webpack_public_path__ + "img/297.60736e82.jpg";